import { ApiError } from '@/lib/api/http-client'

type ProfileTranslator = (key: string) => string

const messageMap: Record<string, string> = {
  'avatar data cannot be empty': 'errors.avatarEmpty',
  'current password is incorrect': 'errors.currentPasswordIncorrect',
  'image data cannot be empty': 'errors.avatarEmpty',
  'image file cannot be empty': 'errors.avatarEmpty',
  'missing avatar data': 'errors.avatarEmpty',
  'missing avatar file': 'errors.avatarEmpty',
  'missing required parameters': 'errors.missingPasswordFields',
  'no avatar file selected': 'errors.avatarEmpty',
  'not a valid image data': 'errors.avatarInvalid',
  'not a valid image file': 'errors.avatarInvalid',
  'timezone must be a valid iana timezone': 'errors.timezoneInvalid',
  'unsupported image format, only support: jpeg, jpg, png, gif, webp': 'errors.avatarUnsupported',
}

/**
 * 用户资料错误文案映射。
 * 当前 profile 相关接口仍有部分错误只返回 message，前台只做白名单兼容，避免直接泄漏后端原文。
 */
export function resolveProfileErrorMessage(error: unknown, t: ProfileTranslator) {
  if (!(error instanceof ApiError)) {
    return t('errors.network')
  }

  if (error.errorCode === 'auth.account_unavailable') {
    return t('errors.accountUnavailable')
  }

  if (error.status === 401) {
    return t('errors.sessionExpired')
  }

  if (error.status === 403) {
    return t('errors.forbidden')
  }

  if (error.status >= 500) {
    return t('errors.serviceUnavailable')
  }

  const normalizedMessage = error.message.trim().toLowerCase()
  const mappedKey = messageMap[normalizedMessage]

  if (mappedKey) {
    return t(mappedKey)
  }

  if (normalizedMessage.startsWith('image file size cannot exceed')) {
    return t('errors.avatarTooLarge')
  }

  return t('errors.generic')
}
